<script lang="ts">
	import '../app.css';
	import Header from '$lib/components/Header.svelte';
	import Footer from '$lib/components/Footer.svelte';

	let { children } = $props();
</script>

<div class={'light bg-background-alt w-full h-screen flex flex-col'}>
	<Header />
	<section class="flex-1 overflow-y-auto scroll-smooth">
		{@render children?.()}
		<Footer />
	</section>
</div>
